
  export const GetAllMasterCategotryGroup = async () => {
    const respone = await fetch("api/Ecatalog/GetAllMasterCategotryGroup")
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };


  // endpoint นี้ return POCO ตรง ๆ ทำให้ ASP.NET serialize เป็น camelCase (ไม่ใช่ PascalCase เหมือน endpoint อื่นที่ส่ง string ที่ serialize เองแล้ว)
  export const GetEcatalogSystemStatus = async () => {
    const respone = await fetch("api/Ecatalog/GetEcatalogSystemStatus")
      .then((response) => response.json())
      .catch((err) => {
        console.log("ecatalog=>GetEcatalogSystemStatus", err);
        return { isClosed: false };
      });

    return respone;
  };

  export const SearchCatalogItem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/SearchCatalogItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetWolfTemplate = async (documentCode: string) => 
  {
    const respone = await fetch("api/Ecatalog/GetWolfTemplate?documentCode=" + documentCode )
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    return respone;//.filter((e: any) => e.IsActive === true);
  };
  
  export const CreateMemorandum = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/CreateMemorandum", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const LineApproval = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/LineApproval", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const InsertTransactionOrderitem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/InsertTransactionOrderitem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetSellerById = async (sellerID: number) => 
  {
    const respone = await fetch("api/Supplier/GetSellerById?SellerID=" + sellerID)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    return respone;//.filter((e: any) => e.IsActive === true);
  };
  
  export const InsertFavoriteItem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/InsertFavoriteItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };
   
  export const DeleteFavoriteItem = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/DeleteFavoriteItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const ReceiveAddress = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/ReceiveAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetBudget = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const SetBudget = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/SetBudget", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetBudgetByEmpCode = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetBudgetByEmpCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const GetUserCart = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/GetUserCart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const AddOrUpdateUserCart = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/AddOrUpdateUserCart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  export const ClearUserCart = async (dataJson: any) => {
    const respone = await fetch("api/Ecatalog/ClearUserCart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;
  };

  
  